module.exports = __webpack_public_path__ + "static/media/shape0_5.4b02e6db.obj";